module.exports = __webpack_public_path__ + "img/credit-icon-2.731931f9.svg";